// Rich translations for the entire application journey (FR + EN)
export const translations = {
  fr: {
    nav: { lang: "EN" },
    hero: {
      eyebrow: "Privé · Structuré · Vérifié",
      brand: "SOMNIUM",
      brandSub: "GROUP",
      tagline:
        "L'écosystème de confiance pour les affaires et les opportunités qualifiées.",
      sub: "Accès réservé. Sur invitation.",
      cta: "Demander mes accès",
      scroll: "Découvrir",
    },
    phone: {
      welcome: "Bienvenue chez",
      access: "Accès réservé",
      tag: "Privé. Structuré. Vérifié.",
    },
    form: {
      eyebrow: "Demande d'accès",
      title: "Nous rejoindre",
      subtitle:
        "Somnium Group connecte des propriétaires d'actifs, des investisseurs, des apporteurs d'affaires et des clients privés au sein d'un écosystème d'échanges vérifiés.\n\nL'accès au réseau est exclusivement accordé sur candidature et après un processus de validation confidentiel visant à garantir la qualité, la fiabilité et la pertinence de chaque membre.\n\nNotre mission est de créer un environnement de confiance où les opportunités, les connexions stratégiques et les transactions peuvent se développer avec efficacité, discrétion et sécurité.",
      fullName: "Nom complet",
      email: "Email professionnel",
      linkedin: "Profil LinkedIn",
      linkedinHint: "URL complète (optionnel mais recommandé)",
      profile: "Votre profil",
      profileOptions: [
        { value: "investor", label: "Investisseur" },
        { value: "owner", label: "Propriétaire d'actifs" },
        { value: "broker", label: "Apporteur d'affaires" },
        { value: "buyer", label: "Acheteur privé" },
        { value: "family-office", label: "Family Office" },
        { value: "entrepreneur", label: "Entrepreneur" },
        { value: "other", label: "Autre" },
      ],
      profilePlaceholder: "Sélectionnez un profil",
      invitationCode: "Code d'invitation",
      invitationHint: "Optionnel",
      message: "Quelques mots sur votre intention",
      messagePlaceholder:
        "Type d'opportunités recherchées, secteurs, géographies…",
      submit: "Envoyer ma demande",
      submitting: "Envoi en cours…",
      legal:
        "En soumettant, vous acceptez d'être contacté de manière confidentielle par Somnium Group. Votre demande sera examinée.",
      requiredFields: "Veuillez renseigner les champs requis.",
      errorGeneric:
        "Une erreur est survenue. Veuillez réessayer dans quelques instants.",
    },
    footer: {
      tagline: "Privé · Structuré · Vérifié",
      copyright: `© ${new Date().getFullYear()} Somnium Group. Tous droits réservés.`,
    },
    app: {
      // Confirmation & continue
      confirmation: {
        eyebrow: "Application received",
        title: "Votre demande a bien été reçue.",
        intro:
          "Merci de votre demande d'accès à Somnium Group. L'étape suivante consiste à compléter votre profil, vérifier votre identité et fournir les informations requises pour l'examen confidentiel de votre candidature.",
        referenceLabel: "Référence de dossier",
        stepsTitle: "Prochaines étapes",
        steps: [
          "Compléter votre profil de membre",
          "Vérifier votre identité",
          "Fournir les documents requis",
          "Soumettre votre dossier pour examen confidentiel",
          "Recevoir la décision de Somnium Group",
        ],
        primaryCta: "Continuer ma candidature",
        secondaryCta: "Continuer plus tard",
        laterHint:
          "Un lien de continuation vous a été envoyé par email. Il reste valable 30 jours.",
      },
      wizard: {
        header: "Candidature de membre",
        percentCompleted: "complétée",
        exit: "Quitter",
        back: "Retour",
        continue: "Continuer",
        save: "Sauvegarder",
        submit: "Soumettre ma candidature",
        submitting: "Soumission…",
        stepLabels: {
          profile: "Profil",
          identity: "Identité",
          activity: "Activité",
          documents: "Documents",
          declarations: "Déclarations",
          review: "Révision",
        },
        stages: {
          personal: {
            label: "Profil",
            chapter: "01",
            title: "Informations personnelles",
            subtitle:
              "Ces informations resteront strictement confidentielles et servent uniquement à l'examen de votre candidature.",
            fields: {
              first_name: "Prénom légal",
              last_name: "Nom légal",
              dob: "Date de naissance",
              nationality: "Nationalité",
              country: "Pays de résidence",
              address: "Adresse",
              city: "Ville",
              postal_code: "Code postal",
              mobile: "Téléphone mobile",
              email: "Email",
              prof_email: "Email professionnel (si différent)",
              language: "Langue préférée",
              linkedin: "Profil LinkedIn",
              website: "Site professionnel (si applicable)",
              occupation: "Profession",
              company: "Entreprise (si applicable)",
              job_title: "Fonction",
            },
            languages: [
              { value: "fr", label: "Français" },
              { value: "en", label: "English" },
            ],
          },
          selection: {
            label: "Profil membre",
            chapter: "02",
            title: "Comment souhaitez-vous participer à Somnium Group ?",
            subtitle:
              "Sélectionnez un ou plusieurs profils. Les questions suivantes s'adapteront à vos choix.",
            multiple: "Plusieurs choix possibles",
            profiles: [
              {
                value: "private_client",
                title: "Client Privé",
                desc: "Je recherche des opportunités privées, des actifs, des services ou des accès.",
              },
              {
                value: "buyer",
                title: "Acheteur",
                desc: "Je cherche activement à acquérir des actifs ou des opportunités.",
              },
              {
                value: "investor",
                title: "Investisseur",
                desc: "Je recherche des opportunités d'investissement.",
              },
              {
                value: "seller",
                title: "Propriétaire / Vendeur",
                desc: "Je possède des actifs ou opportunités que je peux souhaiter offrir via Somnium.",
              },
              {
                value: "introducer",
                title: "Apporteur d'affaires",
                desc: "J'apporte des acheteurs, vendeurs, investisseurs, propriétaires ou opportunités.",
              },
              {
                value: "professional",
                title: "Professionnel / Partenaire",
                desc: "Je fournis des services professionnels ou représente une entreprise.",
              },
              {
                value: "company",
                title: "Représentant d'entreprise",
                desc: "Je candidate au nom d'une entreprise ou organisation.",
              },
            ],
          },
          questions: {
            label: "Activité",
            chapter: "03",
            title: "Questions dédiées à votre profil",
            subtitle:
              "Répondez avec précision. Ces éléments guideront l'examen confidentiel de votre dossier.",
            yes: "Oui",
            no: "Non",
            sometimes: "Parfois",
            some: "Certains",
            always: "Toujours",
            often: "Souvent",
            rarely: "Rarement",
            never: "Jamais",
          },
          declarations: {
            label: "Déclarations",
            chapter: "04",
            title: "Déclarations & accords",
            subtitle:
              "Avant la soumission finale, veuillez confirmer chacun des points suivants.",
            items: [
              "Je confirme que toutes les informations fournies à Somnium Group sont complètes et exactes.",
              "Je confirme que tous les documents soumis sont authentiques et n'ont pas été intentionnellement altérés ou falsifiés.",
              "Je comprends que Somnium Group peut vérifier indépendamment les informations fournies, lorsque cela est approprié et légalement permis.",
              "Je m'engage à ne pas soumettre en connaissance de cause des actifs ou opportunités que je ne possède pas ou pour lesquels je n'ai pas d'autorité.",
              "Je m'engage à divulguer précisément ma relation avec toute opportunité soumise à Somnium Group.",
              "Je comprends que mon adhésion peut être suspendue ou résiliée si des informations matériellement fausses ou frauduleuses sont fournies.",
              "J'accepte les Conditions d'adhésion de Somnium Group.",
              "Je reconnais les règles de confidentialité et de non-contournement de Somnium Group.",
            ],
            signatureTitle: "Signature électronique",
            signatureName: "Nom complet légal",
            signatureDate: "Date",
            signatureAck: "En saisissant mon nom, je signe électroniquement ces déclarations.",
          },
          identity: {
            label: "Vérification d'identité",
            chapter: "05",
          },
          review: {
            label: "Révision",
            chapter: "06",
            title: "Révisez votre candidature",
            subtitle:
              "Vérifiez toutes vos informations avant la soumission finale à Somnium Group.",
            personal: "Informations personnelles",
            selection: "Profil de membre",
            questions: "Informations dédiées",
            declarations: "Déclarations",
            complete: "Complet",
            incomplete: "Incomplet",
            edit: "Modifier",
            missingWarning: "Certaines sections nécessitent votre attention.",
            submit: "Soumettre ma candidature",
          },
          submitted: {
            eyebrow: "Application submitted",
            title: "Votre candidature a été soumise.",
            intro:
              "Votre dossier complet a été transmis à Somnium Group pour examen confidentiel. Vous serez informé si des informations complémentaires sont requises.",
            timeline: [
              { key: "initial", label: "Demande initiale", done: true },
              { key: "profile", label: "Profil de membre", done: true },
              { key: "identity", label: "Vérification d'identité", done: false, note: "À venir" },
              { key: "documents", label: "Documents", done: false, note: "À venir" },
              { key: "submitted", label: "Candidature soumise", done: true },
              { key: "review", label: "Examen Somnium Group", done: "current" },
              { key: "decision", label: "Décision finale", done: false },
              { key: "passport", label: "Trust Passport", done: false },
            ],
            close: "Vous pouvez fermer cette fenêtre.",
          },
        },
      },
    },
  },
  en: {
    nav: { lang: "FR" },
    hero: {
      eyebrow: "Private · Structured · Verified",
      brand: "SOMNIUM",
      brandSub: "GROUP",
      tagline:
        "The trusted ecosystem for qualified business and opportunities.",
      sub: "Access by invitation only.",
      cta: "Request access",
      scroll: "Discover",
    },
    phone: {
      welcome: "Welcome to",
      access: "Reserved access",
      tag: "Private. Structured. Verified.",
    },
    form: {
      eyebrow: "Request access",
      title: "Join us",
      subtitle:
        "Somnium Group connects asset owners, investors, deal-makers and private clients within an ecosystem of verified exchanges.\n\nAccess to the network is granted exclusively upon application and after a confidential validation process designed to ensure the quality, reliability and relevance of each member.\n\nOur mission is to create a trusted environment where opportunities, strategic connections and transactions can grow with efficiency, discretion and security.",
      fullName: "Full name",
      email: "Professional email",
      linkedin: "LinkedIn profile",
      linkedinHint: "Full URL (optional but recommended)",
      profile: "Your profile",
      profileOptions: [
        { value: "investor", label: "Investor" },
        { value: "owner", label: "Asset Owner" },
        { value: "broker", label: "Deal Maker / Broker" },
        { value: "buyer", label: "Private Buyer" },
        { value: "family-office", label: "Family Office" },
        { value: "entrepreneur", label: "Entrepreneur" },
        { value: "other", label: "Other" },
      ],
      profilePlaceholder: "Select a profile",
      invitationCode: "Invitation code",
      invitationHint: "Optional",
      message: "A few words on your intent",
      messagePlaceholder:
        "Type of opportunities, sectors, geographies you focus on…",
      submit: "Send my request",
      submitting: "Sending…",
      legal:
        "By submitting, you agree to be contacted confidentially by Somnium Group. Your request will be reviewed.",
      requiredFields: "Please fill in the required fields.",
      errorGeneric: "Something went wrong. Please try again in a few moments.",
    },
    footer: {
      tagline: "Private · Structured · Verified",
      copyright: `© ${new Date().getFullYear()} Somnium Group. All rights reserved.`,
    },
    app: {
      confirmation: {
        eyebrow: "Application received",
        title: "Your request has been received.",
        intro:
          "Thank you for requesting access to Somnium Group. The next stage consists of completing your profile, verifying your identity and providing the information required for Somnium Group to assess your membership application.",
        referenceLabel: "Application reference",
        stepsTitle: "Your next steps",
        steps: [
          "Complete your membership profile",
          "Verify your identity",
          "Provide the required supporting documents",
          "Submit your complete application for review",
          "Receive Somnium Group's decision",
        ],
        primaryCta: "Continue my application",
        secondaryCta: "Continue later",
        laterHint:
          "A continuation link has been emailed to you. It remains valid for 30 days.",
      },
      wizard: {
        header: "Membership Application",
        percentCompleted: "completed",
        exit: "Exit",
        back: "Back",
        continue: "Continue",
        save: "Save",
        submit: "Submit my application",
        submitting: "Submitting…",
        stepLabels: {
          profile: "Profile",
          identity: "Identity",
          activity: "Activity",
          documents: "Documents",
          declarations: "Declarations",
          review: "Review",
        },
        stages: {
          personal: {
            label: "Profile",
            chapter: "01",
            title: "Personal information",
            subtitle:
              "This information remains strictly confidential and is used solely for the review of your application.",
            fields: {
              first_name: "Legal first name",
              last_name: "Legal last name",
              dob: "Date of birth",
              nationality: "Nationality",
              country: "Country of residence",
              address: "Address",
              city: "City",
              postal_code: "Postal code",
              mobile: "Mobile number",
              email: "Email",
              prof_email: "Professional email (if different)",
              language: "Preferred language",
              linkedin: "LinkedIn profile",
              website: "Professional website (if applicable)",
              occupation: "Occupation",
              company: "Company (if applicable)",
              job_title: "Job title",
            },
            languages: [
              { value: "fr", label: "Français" },
              { value: "en", label: "English" },
            ],
          },
          selection: {
            label: "Member profile",
            chapter: "02",
            title: "How do you intend to participate in Somnium Group?",
            subtitle:
              "Select one or more profiles. Subsequent questions will adapt to your choices.",
            multiple: "Multiple selections allowed",
            profiles: [
              {
                value: "private_client",
                title: "Private Client",
                desc: "I am looking for private opportunities, assets, services or access.",
              },
              {
                value: "buyer",
                title: "Buyer",
                desc: "I am actively looking to acquire assets or opportunities.",
              },
              {
                value: "investor",
                title: "Investor",
                desc: "I am looking for investment opportunities.",
              },
              {
                value: "seller",
                title: "Asset Owner / Seller",
                desc: "I own assets or opportunities that I may wish to offer through Somnium.",
              },
              {
                value: "introducer",
                title: "Business Introducer",
                desc: "I introduce buyers, sellers, investors, owners or business opportunities.",
              },
              {
                value: "professional",
                title: "Professional / Partner",
                desc: "I provide professional services or represent a business.",
              },
              {
                value: "company",
                title: "Company Representative",
                desc: "I am applying on behalf of a company or organisation.",
              },
            ],
          },
          questions: {
            label: "Activity",
            chapter: "03",
            title: "Profile-specific questions",
            subtitle:
              "Answer precisely — these details guide the confidential review of your file.",
            yes: "Yes",
            no: "No",
            sometimes: "Sometimes",
            some: "Some of them",
            always: "Always",
            often: "Often",
            rarely: "Rarely",
            never: "Never",
          },
          declarations: {
            label: "Declarations",
            chapter: "04",
            title: "Declarations & Agreements",
            subtitle:
              "Before final submission, please confirm each of the following points.",
            items: [
              "I confirm that all information provided to Somnium Group is complete and accurate.",
              "I confirm that all documents submitted are authentic and have not been intentionally altered or falsified.",
              "I understand that Somnium Group may independently verify information provided where appropriate and legally permitted.",
              "I agree not to knowingly submit assets or opportunities that I do not own or have authority to represent.",
              "I agree to accurately disclose my relationship with any opportunity submitted to Somnium Group.",
              "I understand that membership may be suspended or terminated if materially false or fraudulent information is provided.",
              "I agree to the Somnium Group Membership Terms.",
              "I acknowledge the Somnium Group Confidentiality and Non-Circumvention Rules.",
            ],
            signatureTitle: "Electronic signature",
            signatureName: "Full legal name",
            signatureDate: "Date",
            signatureAck: "By typing my name, I electronically sign these declarations.",
          },
          identity: {
            label: "Identity verification",
            chapter: "05",
          },
          review: {
            label: "Review",
            chapter: "06",
            title: "Review your application",
            subtitle:
              "Check all your information before submitting to Somnium Group.",
            personal: "Personal information",
            selection: "Member profile",
            questions: "Profile-specific info",
            declarations: "Declarations",
            complete: "Complete",
            incomplete: "Incomplete",
            edit: "Edit",
            missingWarning: "Some sections require your attention.",
            submit: "Submit my application",
          },
          submitted: {
            eyebrow: "Application submitted",
            title: "Your application has been submitted.",
            intro:
              "Your complete application has been submitted to Somnium Group for confidential review. You will be notified if additional information is required.",
            timeline: [
              { key: "initial", label: "Initial request", done: true },
              { key: "profile", label: "Membership profile", done: true },
              { key: "identity", label: "Identity verification", done: false, note: "Upcoming" },
              { key: "documents", label: "Documents", done: false, note: "Upcoming" },
              { key: "submitted", label: "Application submitted", done: true },
              { key: "review", label: "Somnium Group review", done: "current" },
              { key: "decision", label: "Final decision", done: false },
              { key: "passport", label: "Trust Passport", done: false },
            ],
            close: "You can close this window.",
          },
        },
      },
    },
  },
};
